<template>
    <div class="toolbar flex align-center justify-space-between">
        <div class="box-left box grow flex">
            <button @click="toggleSidebar" v-if="menuBurger !== 'right'"
                    class="toggle-sidebar card-base card-shadow--small">
                <i class="mdi mdi-menu"></i>
            </button>
        </div>
        <div class="box-right flex align-center pl-10">

<!--            <el-button type="text" icon="el-icon-s-tools" style="font-size: 24px; margin-right: 10px" class="fullscreen-button" v-on:click="drawerSiparis= true">-->
<!--            </el-button>-->

            <el-tooltip class="item" effect="dark" content="Alarm Durumu" placement="bottom">
                <el-switch style="margin-right: 10px;" v-on:change="zilDurumGuncelle" active-icon-class="el-icon-message-solid" inactive-icon-class="el-icon-close-notification" v-model="zilDurum">
                </el-switch>
            </el-tooltip>


            <el-tooltip class="item" effect="dark" content="Sipariş Alma Durumu" placement="bottom">
                <el-switch v-on:change="siparisDurumDegistir" v-model="siparisDurum">
                </el-switch>
            </el-tooltip>

            <button class="fullscreen-button" @click="toggleFullscreen">
                <i class="mdi mdi-fullscreen" v-if="!fullscreen"></i>
                <i class="mdi mdi-fullscreen-exit" v-if="fullscreen"></i>
            </button>
            <span class="username effect-shine" style="cursor: pointer" v-on:click="onCommand('profile')">{{userdata.adSoyad}}</span>
            <el-dropdown trigger="click" @command="onCommand">
				<span class="el-dropdown-link">
                    <img v-if="userdata.image" :src="imageUrl+userdata.image" class="avatar" alt="avatar">
                    <img v-else src="@/assets/images/avatar.jpg" class="avatar" alt="avatar">
				</span>
                <el-dropdown-menu slot="dropdown" trigger="click" @command="onCommand">
                    <el-dropdown-item command="profile"><i class="mdi mdi-account mr-10"></i> Profil
                    </el-dropdown-item>
                    <el-dropdown-item v-on:click="drawer=true" command="sifre"><i class="mdi mdi-key mr-10"></i> Şifre
                        Güncelle
                    </el-dropdown-item>
                    <el-dropdown-item command="logout" divided><i class="mdi mdi-logout mr-10"></i> Çıkış
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-drawer
                    size="35%"
                    title="Yönetici Bilgileri"
                    :visible.sync="drawer"
                    direction="rtl"
                    :append-to-body="true"
                    custom-class="demo-drawer"
                    ref="drawer">
                <div class="demo-drawer__content">
                    <el-form status-icon :model="form" :rules="rulesForm" ref="form"
                             class="demo-ruleForm formPadding">
                        <el-form-item label='Eski Şifre' prop="eskisifre">:
                            <el-col :span="24">
                                <el-input type="password" v-model="form.eskisifre"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label='Yeni Şifre' prop="sifre">:
                            <el-col :span="24">
                                <el-input type="password" v-model="form.sifre"></el-input>
                                <password v-model="form.sifre" :strength-meter-only="true"/>
                            </el-col>
                        </el-form-item>
                        <el-form-item label='Yeni Şifre (Tekrar)' prop="sifre2">:
                            <el-col :span="24">
                                <el-input type="password" v-model="form.sifre2"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-button
                                type="primary"
                                size="mini"
                                v-on:click="editPass('form')"> Güncelle
                        </el-button>
                    </el-form>
                </div>
            </el-drawer>
            <el-drawer
                    size="30%"
                    title="Sipariş Alınabilme Durumu"
                    :visible.sync="drawerSiparis"
                    direction="rtl"
                    :append-to-body="true"
                    custom-class="demo-drawer"
                    ref="drawer">
                <div class="demo-drawer__content">
                    <el-form status-icon :model="formSiparis" :rules="rulesFormSiparis" ref="formSiparis"
                             class="demo-ruleForm formPadding">
                        <el-row :gutter="15">
                            <el-col :span="12">
                            <el-form-item label='Başlangıç Saati' prop="baslangicSaat1">:
                                <el-time-select
                                    v-model="formSiparis.baslangicSaat1"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:15',
                                        end: '23:45'
                                      }"
                                    placeholder="Başlangıç Saati">
                                </el-time-select>
                            </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label='Bitiş Saati' prop="bitisSaat1">:
                                    <el-time-select
                                        v-model="formSiparis.bitisSaat1"
                                        :picker-options="{
                                            start: '00:00',
                                            step: '00:15',
                                            end: '23:45'
                                        }"
                                        placeholder="Bitiş Saati">
                                    </el-time-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="15">
                            <el-col :span="12">
                            <el-form-item label='Başlangıç Saati' prop="baslangicSaat2">:
                                <el-time-select
                                    v-model="formSiparis.baslangicSaat2"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:15',
                                        end: '23:45'
                                    }"
                                    placeholder="Bitiş Saati">
                                </el-time-select>
                            </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label='Bitiş Saati' prop="bitisSaat2">:
                                    <el-time-select
                                        v-model="formSiparis.bitisSaat2"
                                        :picker-options="{
                                            start: '00:00',
                                            step: '00:15',
                                            end: '23:45'
                                        }"
                                        placeholder="Bitiş Saati">
                                    </el-time-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="text-right">
                            <el-button
                                type="primary"
                                size="mini"
                                v-on:click="siparisAktifDegistir('formSiparis')"> Sipariş Saatini Değiştir
                            </el-button>
                        </div>
                    </el-form>
                </div>
            </el-drawer>
            <button @click="toggleSidebar" v-if="menuBurger === 'right'" class="toggle-sidebar toggle-sidebar__right card-base card-shadow--small">
                <i class="mdi mdi-menu"></i>
            </button>
        </div>
    </div>
</template>

<script>
    import musteriService from "../WSProvider/MusteriService";  
    import yonetimService from '../WSProvider/YoneticiService'
    import calismaService from '../WSProvider/CalismaService'
    import Password from 'vue-password-strength-meter'
    import notification from '../notification'

    import sound from "@/assets/voices/mixkit-phone-ring-bell-593.wav"
    import EventBus from '@/components/event-bus'
    import JQuery from 'jquery';
import { type } from 'os';

    let $ = JQuery;

    var base64 = require('base64_js');
    var crypto = require('crypto');
    var userDataKader = '';

    export default {
        name: 'Toolbar',
        props: ['menuBurger'],
        components: {
            Password
        },

        computed: {
            zilDurumStore(val){
                return this.$store.getters.getZilDurum;
            }
        },
        watch: {
            zilDurumStore(val){
                this.zilDurum = val;
            }
        },

        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Lütfen Şifre Giriniz'));
                } else {
                    if (this.form.sifre2 !== '') {
                        this.$refs.form.validateField('sifre2');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Lütfen Şifreyi Tekrar Giriniz'));
                } else if (value !== this.form.sifre) {
                    callback(new Error('Şifreler Uyuşmuyor!!'));
                } else {
                    callback();
                }
            };
            return {
                userInteractCounter: 0,
                zil: null,
                audio : null,
                zilDurum: false,
                tabList : [],
                urlName: '',
                siparisDurum: true,
                imageUrl: yonetimService.imageUrlKucuk,
                drawer: false,
                drawerSiparis: false,
                sifreTekrarVis: false,
                dialog: false,
                popoverWidth: 300,
                fullscreen: false,
                lang: 'tr',
                userdata: '',
                updateData: [],
                yoneticiDetayListesi: [],
                visibleSifre: false,
                form: {
                    eskisifre: '',
                    sifre: '',
                    sifre2: ''
                },
                formSiparis: {
                    baslangicSaat1: '',
                    bitisSaat1: '',
                    baslangicSaat2: '',
                    bitisSaat2: '',
                },
                rulesForm: {
                    eskisifre: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    sifre: [
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    sifre2: [
                        {validator: validatePass2, trigger: 'blur'}
                    ],
                },
                rulesFormSiparis: {
                    baslangicSaat1: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    bitisSaat1: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    baslangicSaat2: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    bitisSaat2: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                }
            }
        },

        
        methods: {
            siparisDurumDegistir(val) {
                var statusDurum;
                if (val) {
                    statusDurum = 1;
                } else {
                    statusDurum = 0;
                }
                calismaService.statusGuncelle(statusDurum).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Sipariş alma durumu başarıyla değiştirildi');
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            siparisAktifDegistir(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        calismaService.mesaiSaati(this.formSiparis.baslangicSaat1,this.formSiparis.baslangicSaat2,this.formSiparis.bitisSaat1, this.formSiparis.bitisSaat2).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Sipariş alma durum saatleri başarıyla değiştirildi');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            getSiparisDurum(){
                calismaService.statusOku().then((response) => {
                    if (response.status === 200) {
                        if (response.data.calismaStatus === 1) {
                            this.siparisDurum = true
                        } else {
                            this.siparisDurum = false
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getSaatBilgileri(){
                calismaService.saatBilgileri().then((response) => {
                    if (response.status === 200) {
                        this.formSiparis.baslangicSaat1 = response.data.baslangic1;
                        this.formSiparis.baslangicSaat2 = response.data.baslangic2;
                        this.formSiparis.bitisSaat1 = response.data.bitis1;
                        this.formSiparis.bitisSaat2 = response.data.bitis2;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            editPass(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        yonetimService.sifreGuncelle(this.form.eskisifre, this.form.sifre).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Şifreniz başarıyla güncellendi. Lütfen yeni şifreniz ile giriş yapınız.');
                                this.$store.commit('setLogout');
                                this.$router.push("/login");
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir yönetici zaten mevcut');

                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            goHome() {
                this.$router.push('/dashboard')
            },
            onCommandLang(lang) {
                if (lang.charAt(0) === '/')
                    this.onCommand(lang)
                else
                    this.lang = lang
            },
            onCommand(path) {
                if (path === "sifre") {
                    this.drawer = true;
                } else if (path === "profile") {
                    var name = "Kişisel Bilgilerim";
                    var obj = this.tabList.find(data => data.title === name);
                    if (obj === undefined) {
                        this.tabList.push({
                            title: name,
                            name:name,
                            contentName: linkTemizle(name.replace(" ", ""))
                        });
                        this.$store.commit('changeTabList', this.tabList);
                        this.$store.commit('changeActiveTabs', name);
                    } else {
                        this.$store.commit('changeActiveTabs', name);
                    }
                } else{
                    var tabList = [];
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeNavVisible', false);
                    localStorage.removeItem("userDataKader");
                    this.$router.push(path)
                }

            },
            toggleSidebar() {
                this.$emit('toggle-sidebar')
            },
            toggleFullscreen() {
                this.$fullscreen.toggle(document.querySelector('body'), {
                    wrap: false,
                    callback: () => {
                        this.fullscreen = this.$fullscreen.getState()
                    }
                })
            },
            zilDurumGuncelle(val){
                if(val === true){
                    this.audio = new Audio(sound)

                    this.zil = setInterval(function(){
                        musteriService.siparisListesi(0, 10,"2").then((response) => {
                            if (response.status === 200 && response.data.length > 0) {
                                this.audio = new Audio(sound)
                                this.audio.play()
                            }
                            EventBus.$emit("onayBekleyenlerGuncelle", true)
                        });   
                    }, 60000) // 1 minute
                }
                else if( val === false){
                    this.audio.pause()
                    clearInterval(this.zil)
                }
                
            },
            zilBildirim(){
                var self = this;
                this.$store.commit("changeZilAcildiMi", true);
                this.$confirm('Zil Bildirimi Aktif Duruma Getirilsin Mi?').then(_ => {
                    self.zilDurumGuncelle(true);
                    this.$store.commit("changeZilDurum", true);
                }).catch(_ => {
                    self.zilDurumGuncelle(false);
                    this.$store.commit("changeZilDurum", false);
                })

            }

        },
        mounted() {
            const self = this;

            if (localStorage.getItem("userDataKader")) {
                this.userdata = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
                this.getSiparisDurum();
                this.getSaatBilgileri();
            } else {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            }

            
            self.auto = new Audio(sound);
            EventBus.$on("zilBildirimGetir", function(bool){
                if(bool){
                    self.zilBildirim();
                }
            })

        },
    }
    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }

</script>

<style lang="scss" scoped>
    @import '../assets/scss/_variables';
    @import '../assets/scss/_mixins';

    .toolbar .username a {
        color: #909399 !important;
        text-decoration: none;
        font-weight: bold !important;
        -webkit-transition: all 0.5s;
        transition: all 0.5s;
    }

    .toolbar {
        width: 100%;
        height: 100%;
        padding: 0 20px;
        box-sizing: border-box;

        .username {
            margin-left: 20px;
            font-weight: bold;
            @include text-bordered-shadow();

            a {
                color: $text-color;
                text-decoration: none;
                transition: all 0.5s;

                &:hover {
                    font-weight: unset;
                    -webkit-mask-image: linear-gradient(-75deg, rgba(0, 0, 0, .6) 30%, #000 50%, rgba(0, 0, 0, .6) 70%);
                    -webkit-mask-size: 200%;
                    animation: shine 2s infinite;
                }
            }
        }

        @-webkit-keyframes shine {
            from {
                -webkit-mask-position: 150%;
            }

            to {
                -webkit-mask-position: -50%;
            }
        }

        .avatar {
            border-radius: 50%;
            width: 35px;
            height: 35px;
            border: 1px solid #FFF;
            margin-left: 20px;
            box-sizing: border-box;
            display: block;
            cursor: pointer;
            box-shadow: 0 2px 5px 0 rgba(49, 49, 93, .1), 0 1px 2px 0 rgba(0, 0, 0, .08);
            transition: box-shadow .5s;

            &:hover {
                box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08), 0px 2px 7px 0 rgba(0, 0, 0, 0.08);
            }
        }

        .notification-icon {
            font-size: 20px;
            outline: none;
            padding: 0;
            background: transparent;
            border: none;
            margin-left: 20px;
            //color: #aab7c5;
            color: transparentize($text-color, 0.7);
            @include text-bordered-shadow();

            &:hover {
                color: $text-color-accent;
            }
        }

        .toggle-sidebar {
            border: 1px solid transparent;
            height: 32px;
            min-height: 32px;
            line-height: 32px;
            width: 32px;
            min-width: 32px;
            max-width: 32px;
            box-sizing: border-box;
            text-align: center;
            margin: 0;
            outline: none;
            margin-right: 5px;
            font-size: 24px;
            padding: 0;
            cursor: pointer;
            display: inline-block;
            color: $text-color;
            background: #e3eaf0;
            display: none;
            opacity: 0;
            transition: all .5s;

            &__right {
                margin-right: 0px;
                margin-left: 5px;
            }

            &:hover, &:focus, &:active {
                color: $text-color-accent;
                border-color: $text-color-accent;
            }
        }

        .fullscreen-button {
            font-size: 24px;
            cursor: pointer;
            outline: none;
            padding: 0;
            background: transparent;
            border: none;
            margin-left: 20px;
            color: white;
            //color: transparentize($text-color, 0.7);
            @include text-bordered-shadow();

            &:hover {
                color: $text-color-accent;
            }
        }

        .el-button {
            margin-left: 0;
        }

        .el-dropdown {
            .flag-icon {
                box-shadow: 0 2px 5px 0 rgba(49, 49, 93, .1), 0 1px 2px 0 rgba(0, 0, 0, .08);
                cursor: pointer;
                border: 1px solid lighten($background-color, 20%);
                background-color: lighten($background-color, 20%);
            }
        }
    }

    @media (max-width: 650px) {
        .toolbar {
            .username {
                display: none;
            }
        }
    }

    @media (max-width: 768px) {
        .toolbar {
            padding: 0 10px;

            .toggle-sidebar {
                display: block;
                opacity: 1;
            }

            .fullscreen-button {
                display: none;
            }
        }
    }


    .mainDiv {
        .label-switch-box {
            display: block;
            clear: both;
            width: 100%;
            text-align: right;
            margin-bottom: 20px;
        }

        .col-p {
            padding: 0 10px;
            box-sizing: border-box;
        }

        .select-wide {
            width: 100%;
        }
    }
</style>
